class Service {
  svcId: number
  svcActive: string
  svcAddr: string
  svcDesc: string
  svcType: string
  svcTypeName: string
  bank: string
  bik: string
  inn: string
  kpp: string
  rs: string
  poluch: string
  urn: string
  oktmo: string
  officeFrgu: string
  svcUpdated: string

  constructor (service: Service) {
    Object.assign(this, service)
  }

  getShortService () {
    return {
      svcId: this.svcId,
      svcTypeName: this.svcTypeName
    }
  }
}

export class Division {
  _id: string
  code: string
  name: string
  address: string
  post_index: string
  region_code: string
  district_name: string
  city_name: string
  services: Service[]

  constructor (division: Division) {
    Object.assign(this, division)

    this.services = this.services.map(item => new Service(item))
  }

  getShortDivision = () => {
    return {
      _id: this._id,
      name: this.name,
      address: this.address,
      services: this.services.map(item => item.getShortService())
    }
  }
}
